import React from "react";
import { useTranslation } from "react-i18next";
import FormInput from "src/components/Common/Form/FormInput";
import { FORM_NAME, PATTERN_NUMBER } from "src/constant/common";

const RCSSigma = ({ register, errors }) => {
  const { t } = useTranslation("gnc-simulator-6dof");
  return (
    <div className="row">
      <h3 className="mcs-block-title">{t("new.MCS.rcs_sigma_title")}</h3>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.RCS_SPECIFIC_IMPULSE}`)}
          name={`MCS.${FORM_NAME.MCS.RCS_SPECIFIC_IMPULSE}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.RCS_SPECIFIC_IMPULSE}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.RCS_SPECIFIC_IMPULSE]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.RCS_SPECIFIC_IMPULSE}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.RCS_SPECIFIC_IMPULSE}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.RCS_SPECIFIC_IMPULSE}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.THRUST_OF_RCS_THRUSTER}`)}
          name={`MCS.${FORM_NAME.MCS.THRUST_OF_RCS_THRUSTER}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_OF_RCS_THRUSTER}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.THRUST_OF_RCS_THRUSTER]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_OF_RCS_THRUSTER}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_OF_RCS_THRUSTER}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.THRUST_OF_RCS_THRUSTER}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.DEAD_TIME_OF_RCS_SYSTEM}`)}
          name={`MCS.${FORM_NAME.MCS.DEAD_TIME_OF_RCS_SYSTEM}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.DEAD_TIME_OF_RCS_SYSTEM}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.DEAD_TIME_OF_RCS_SYSTEM]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.DEAD_TIME_OF_RCS_SYSTEM}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.DEAD_TIME_OF_RCS_SYSTEM}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.DEAD_TIME_OF_RCS_SYSTEM}`) })}
        />
      </div>
      <div className="col-md-6">
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.FUEL_MASS_RCS}`)}
          name={`MCS.${FORM_NAME.MCS.FUEL_MASS_RCS}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_MASS_RCS}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.FUEL_MASS_RCS]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_MASS_RCS}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_MASS_RCS}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.FUEL_MASS_RCS}`) })}
        />
        <FormInput
          register={register}
          classGroup="ms-2"
          label={t(`new.MCS.${FORM_NAME.MCS.TIME_CONSTANT_OF_RCS_SYSTEM}`)}
          name={`MCS.${FORM_NAME.MCS.TIME_CONSTANT_OF_RCS_SYSTEM}`}
          placeholder={t("new.field_placeholder", { field: t(`new.MCS.${FORM_NAME.MCS.TIME_CONSTANT_OF_RCS_SYSTEM}`) })}
          classInput="width-by-percent-80"
          errors={errors?.MCS?.[FORM_NAME.MCS.TIME_CONSTANT_OF_RCS_SYSTEM]?.message}
          requiredMessage={t("new.field_required", { field: t(`new.MCS.${FORM_NAME.MCS.TIME_CONSTANT_OF_RCS_SYSTEM}`) })}
          required
          pattern={{
            value: PATTERN_NUMBER,
            message: t("new.number_validate", { field: t(`new.MCS.${FORM_NAME.MCS.TIME_CONSTANT_OF_RCS_SYSTEM}`) }),
          }}
          maxLength={255}
          maxLengthMessage={t("new.field_maxlength", { field: t(`new.MCS.${FORM_NAME.MCS.TIME_CONSTANT_OF_RCS_SYSTEM}`) })}
        />
      </div>
    </div>
  );
};

export default RCSSigma;
